import { selectRouterPathname } from '@noths/polaris-client-next-redux';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { push, replace } from 'connected-next-router';

import { buildListingsURLFromState } from 'src/adapters/storeToPageURL/state/buildListingsURLFromState';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { extractBasePath } from 'src/utils/extractBasePath';

interface UpdatePageURLWithQueryOptions {
  history?: 'push' | 'replace';
}

export const updatePageURLWithQuery = createAsyncThunk<void, UpdatePageURLWithQueryOptions | void>(
  'products/updatePageURLWithQuery',
  async (options, { dispatch, getState }) => {
    const { history = 'push' } = options ?? {};
    const state = getState() as ReduxApplicationState;
    const { pathname } = state.router.location;
    const routerPathname = selectRouterPathname(state);
    const { taxonomyAttributeAliases = [] } = state.productsQuery;

    if (taxonomyAttributeAliases.length > 0) {
      const url = buildListingsURLFromState(state);
      dispatch((history === 'push' ? push : replace)(url, url, { shallow: true, scroll: false }));
      return;
    }

    // Non-taxonomy routes carry no taxonomy levels, so every active facet is a
    // filter. `href` uses the Next route pattern, `as` the displayed path — the
    // two URLs differ only in their base path.
    const href = buildListingsURLFromState(state, { basePath: extractBasePath(routerPathname) });
    const as = buildListingsURLFromState(state, { basePath: extractBasePath(pathname) });

    dispatch((history === 'push' ? push : replace)(href, as, { shallow: true, scroll: false }));
  },
);
